import { getQueryDefinition } from '@intelligence/services/common';
import { extractTextFromResponse } from '@intelligence/pages/LowCodeTemplate/utils';

// 复用 LowCodeTemplate 的 extractTextFromResponse 方法
export { extractTextFromResponse };

// COS region 类型
export type ICOSRegion = 'guangzhou' | 'singapore' | string;

export interface LowcodeTemplateConfigEntry {
  templatePath: string;
  /**
   * COS config includes explicit locale variants, e.g. `dataPath_en-US`, `dataPath_zh-CN`.
   * Legacy `dataPath` is deprecated and may be absent.
   */
  dataPath?: string;
  /**
   * COS region for fetching template resources
   * Priority: this field > default 'guangzhou'
   *
   * Recommended values:
   * - 'guangzhou': Guangzhou COS bucket
   * - 'singapore': Singapore COS bucket
   *
   * @example
   * {
   *   "templatePath": "templates/example/index.html",
   *   "dataPath_en-US": "templates/example/data-en.json",
   *   "cos_region": "singapore"
   * }
   *
   * @default 'guangzhou' (if not specified, falls back to default)
   */
  cos_region?: ICOSRegion;
  title?: string;
  [key: string]: any;
}

export type LowcodeTemplateConfig = Record<string, LowcodeTemplateConfigEntry>;

export const fetchCOSPath = () =>
  getQueryDefinition(
    {
      configure_texts: {
        target: 'game_config',
        params: {
          key: 'lowcode_template',
        },
      },
    },
    false,
  );

// Iframe injection constants
export const IFRAME_SCRIPT_READY_DELAY = 200;
export const DATA_INJECTION_FUNCTION_NAMES = ['setLowcodeTemplateData', 'setData'] as const;

// 支持的语言类型
export const SUPPORTED_LOCALES = ['en-US', 'zh-CN'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

/**
 * 标准化 locale
 */
export const normalizeLocale = (locale?: string): SupportedLocale | '' => {
  if (!locale) return '';
  const lower = locale.toLowerCase();
  if (lower === 'zh-cn') return 'zh-CN';
  if (lower === 'en-us') return 'en-US';
  return '';
};
